import request from "./index";
// import qs from 'qs'
const isProduction = process.env.NODE_ENV === "production";
const activityBaseUrl = "https://login.xueersi.com/";

const baseUrl = "https://api.xueersi.com/";
const payUrl = "https://trade.xueersi.com/";

// 可以获取用户id的登录态检查方法
export const checkLogin = () =>
  request.get(activityBaseUrl + "V1/Web/checkLogin");

// 获取不同类型课程数量
export const courseNum = () =>
  request.get(baseUrl + "sequelcenter/contCourse/courseNum");

// 获取首页信息
export const getContCourseIndex = (params) =>
  request.get(baseUrl + "sequelcenter/contCourse/index", { params: params });

// 获取首页加价购商品列表
export const getAddPriceBuyList = (params) => {
  return request.post(baseUrl + "sequelcenter/contCourse/incList", params);
};

// 获取二级页面信息 改为post请求
export const postSubPageIndex = (params) => {
  params.brand = 1;
  return request.post(baseUrl + "sequelcenter/subPage/index", params);
};

// 获取选中项信息
export const postCheckIndex = (params) => {
  // 品牌 => 1：学科 128：素质
  params.brand = 1;
  return request.post(baseUrl + "sequelcenter/check/index", params);
};

// 二级页换课接口
export const getChangeCourse = (params) => {
  // 品牌 => 1：学科 128：素质
  params.brand = 1;
  return request.get(baseUrl + "sequelcenter/changeCourse/index", {
    params: params,
  });
};

// 获取推荐课程二级页
export const postRecomSubPageList = (params) => {
  params.brand = 1;
  return request.post(baseUrl + "sequelcenter/recomSubPage/list", params);
};

// 获取用户优惠券列表
export const postUsercouponList = (params) => {
  return request.post(baseUrl + "cardcoupon/usercoupon/list", params);
};

// 加车app https://api.xueersi.com/shoppingcart/app/addcart
export const postAddCart = (data) =>
  request.post(baseUrl + "shoppingcart/app/addcart", data, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
  });
/**
 * 校验是否可买
 * @param {string} productIds 商品id，多个课程用逗号分割
 * @param {number} source 订单来源
 * @param {number} productType 课程类型
 */
export const postIsCanBuy = (params) =>
  request.get(payUrl + "PC/Order/IsCanBuy/index", { params });
//   request.post(payUrl + "PC/Order/IsCanBuy/index", params);

// 获取购物车内数量
export const getcartcount = (data) =>
  request.get(baseUrl + "shoppingcart/app/getcartcount", data);

// 获取原班课程二级页
export const getSubPageList = (params) => {
  params.brand = 1;
  return request.get(baseUrl + "sequelcenter/subPage/list", { params });
};

// 获取推荐课程二级页
export const getRecomSubPageList = (params) => {
  params.brand = 1;
  return request.get(baseUrl + "sequelcenter/recomSubPage/list", { params });
};
// 获取二级页加价购课程列表
export const getAddPriceBuyPageList = (params) => {
  params.brand = 1;
  return request.post(
    baseUrl + "sequelcenter/contCourse/incChangeList",
    params
  );
};
// 二级页换课接口
export const postChangeCourse = (params) => {
  // 品牌 => 1：学科 128：素质
  params.brand = 1;
  return request.post(baseUrl + "sequelcenter/changeCourse/index", params);
};
export const idEncode = (data) => {
  return request.post(`${baseUrl}porder/v1/tool/idencode`, data);
};
